/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Employee from './Employee/index'
import ExternalProfessional from './ExternalProfessional/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Profiles/Content/Profile/ProfileData/Tag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: personValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Employee'}>
<Employee
  viewPath={`${viewPath}/Employee`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ExternalProfessional'}>
<ExternalProfessional
  viewPath={`${viewPath}/ExternalProfessional`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}